__turbopack_context__.v({
  "className": "brandon_grotesque_f5a803a8-module__pnhNxa__className",
  "variable": "brandon_grotesque_f5a803a8-module__pnhNxa__variable",
});
